import { z } from "zod";
import { TTranslationData } from "../common/translation";
import { TObjectBase } from "../base";
import { TCRUDBy } from "../common/CRUDBy";

export type INotificationAfterSettings = z.infer<
  typeof TNotificationAfterSettings
>;
export const TNotificationAfterSettings = z.object({
  interval: z.number().optional(),
  daysAfter: z.number(),
  text: z.object({}).optional(),
});

export type INotificationTaskRole = z.infer<typeof TNotificationTaskRole>;
export const TNotificationTaskRole = z.enum([
  "responsibles",
  "executors",
  "createdBy.userID",
]);

export type INotificationTaskRoles = z.infer<typeof TNotificationTaskRoles>;
export const TNotificationTaskRoles = z.array(TNotificationTaskRole);

export type INotificationPlatformSettings = z.infer<
  typeof TNotificationPlatformSettings
>;
export const TNotificationPlatformSettings = z.object({
  email: z.boolean(),
  mobile: z.boolean(),
});

export type INotificationPropertyRoleSettings = z.infer<
  typeof TNotificationPropertyRoleSettings
>;
export const TNotificationPropertyRoleSettings = z.object({
  admin: z.boolean().optional(),
});

export type INotificationPropertyRolesSettings = z.infer<
  typeof TNotificationPropertyRolesSettings
>;
export const TNotificationPropertyRolesSettings = z.record(
  TNotificationPropertyRoleSettings.nullable()
);

export type INotificationSettingsField = z.infer<
  typeof TNotificationSettingsField
>;
export const TNotificationSettingsField = z.object({
  operationManager: z.boolean().optional(),
  deviationRoles: TNotificationTaskRoles.optional(),
  propertyRoles: TNotificationPropertyRolesSettings.optional(),
  platforms: TNotificationPlatformSettings.optional(),

  // Unique
  after: TNotificationAfterSettings.optional(),
  text: TTranslationData.optional(),
});

export type IRawNotificationSettings = z.infer<typeof TRawNotificationSettings>;
export const TRawNotificationSettings = z.object({
  id: z.string(),
  deviations: z.record(TNotificationSettingsField),
  ai: z.optional(z.record(TNotificationSettingsField)),
  deletedBy: z.optional(TCRUDBy),
  createdBy: z.optional(TCRUDBy),
  updatedBy: z.optional(TCRUDBy),
});
